import React, { useEffect } from 'react';
import { useNetworkError } from '@/context/NetworkErrorProvider';
import NetworkErrorPage from '@/pages/NetworkError/NetworkError';

interface NetworkStatusMonitorProps {
  children: React.ReactNode;
}

export const NetworkStatusMonitor: React.FC<NetworkStatusMonitorProps> = ({ children }) => {
  const { setNetworkError, hasNetworkError } = useNetworkError();

  useEffect(() => {
    const handleOnline = () => {
      setNetworkError(false);
      window.location.reload();
    };

    const handleOffline = () => {
      setNetworkError(true);
    };

    // Set initial state based on navigator.onLine
    if (!navigator.onLine && !hasNetworkError) {
      setNetworkError(true);
    }

    // Add event listeners for online/offline events
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setNetworkError, hasNetworkError]);

  return (
    <React.Fragment>
      {hasNetworkError ? <NetworkErrorPage onRefresh={() => window.location.reload()} /> : children}
    </React.Fragment>
  );
};

export default NetworkStatusMonitor;
